export default __webpack_public_path__ + "static/media/Tradeop.bb716860.jpg";